// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button[data-v-5d4af45c]{margin-right:3rem;width:255px}.transfer-commission[data-v-5d4af45c]{width:130px}", ""]);
// Exports
module.exports = exports;
